/**
 * <topbar-free-shipping>
 * Topbar hint "Versandkostenfrei ab € X" (server-rendered for the buyer's country from the shipping rules).
 * Once the cart total reaches the free-shipping threshold of that country, the text switches to
 * "Du erhältst Gratisversand" and back again if the cart drops below it.  Threshold in a foreign cart currency
 * is converted with the live Shopify rate (same approach as free-shipping-note.js).
 */
if (!customElements.get('topbar-free-shipping')) {
  class TopbarFreeShipping extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-topbar-free-text]');
      this.defaultText = this.textEl.textContent;
      this.reachedText = this.dataset.reachedText;
      this.threshold = this.thresholdInCartCurrency();
      if (!this.threshold) return;

      this.onCartUpdated = (event) => this.update(event.detail?.cart?.total_price);
      document.addEventListener('cart:updated', this.onCartUpdated);
      this.cartUnsubscriber = window.FoxTheme?.pubsub?.subscribe(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      this.refresh();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this.onCartUpdated);
      this.cartUnsubscriber?.();
    }

    thresholdInCartCurrency() {
      const from = parseFloat(this.dataset.freeFrom);
      if (!(from > 0)) return null;
      if (this.dataset.ruleCurrency === this.dataset.currency) return from;
      if (this.dataset.ruleCurrency === this.dataset.shopCurrency) {
        const rate = parseFloat(window.Shopify?.currency?.rate);
        if (Number.isFinite(rate) && rate > 0) return from * rate;
      }
      return null;
    }

    async refresh() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        this.update((await response.json()).total_price);
      } catch (error) {}
    }

    update(totalCents) {
      const reached = (Number(totalCents) || 0) / 100 >= this.threshold;
      this.textEl.textContent = reached ? this.reachedText : this.defaultText;
      this.classList.toggle('topbar-free-shipping--reached', reached);
    }
  }
  customElements.define('topbar-free-shipping', TopbarFreeShipping);
}
